import { NominationForStaff } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationForStaff: (
  fetchContext: FetchContext,
  nominationId: number,
  countryId?: number,
  accessToken?: string,
) => Promise<NominationForStaff> = (fetchContext, nominationId, countryId, accessToken) => {
  const searchParams = new URLSearchParams();
  if (countryId !== undefined) searchParams.append('countryId', countryId.toString());

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}${searchParams.size > 0 ? `?${searchParams}` : ''}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => responseErrorHandler<NominationForStaff>(fetchContext.errorStore, response, 'get nomination for staff'));
}
